import React from "react"
import HeroSection from "../FAQs/hero-section"
import DescriptionSection from "./description-section"

const PrivacyPolicy = () => {
  return (
    <>
      <HeroSection title="Privacy Policy" />
      <DescriptionSection />
    </>
  )
}

export default PrivacyPolicy
